import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { enqueueSnackbar } from 'notistack';

import { useDeleteTechnicianModalStore } from './DeleteTechnicianModalStore';

import useDeleteTechFromSite from 'hooks/Object/useDeleteTechFromSite';

interface DeleteTechnicianModalProps {
  refetch: () => void;
}

const DeleteTechnicianModal: React.FC<DeleteTechnicianModalProps> = ({ refetch }) => {
  const { t } = useTranslation();
  const { isOpen, objectSlug, siteTechnician, close } = useDeleteTechnicianModalStore();
  const { deleteTech } = useDeleteTechFromSite();

  const techId = siteTechnician?.technician?.id;

  const techDisplayName = useMemo(() => {
    if (!siteTechnician?.technician) return '';
    const { first_name, last_name, email } = siteTechnician.technician;
    const full = [first_name, last_name].filter(Boolean).join(' ').trim();
    return full || email || '';
  }, [siteTechnician]);

  const onDeleteTechnicianFromSite = () => {
    if (!objectSlug || !techId) return;

    deleteTech(
      { objectSlug, techId },
      {
        onError: (error: any) => {
          const msgBackendTechinician = error?.response?.data[0];
          if (msgBackendTechinician) {
            enqueueSnackbar(msgBackendTechinician, { variant: 'error' });
            return;
          }
          const msg = error?.response?.data?.detail || error?.response?.data?.message;
          enqueueSnackbar(msg, { variant: 'error' });
        },
        onSuccess: async () => {
          enqueueSnackbar(t('Modals.removeTechnicianModal.successRemove'), {
            variant: 'success',
          });

          await refetch();

          close();
        },
      },
    );
  };

  return (
    <div>
      <Modal isOpen={isOpen} toggle={close} size="md">
        <ModalHeader className="border-bottom pt-3 pb-2" toggle={close}>
          <div className="text-purple">{t('Modals.removeTechnicianModal.title')}</div>
        </ModalHeader>

        <ModalBody>
          {t('Modals.delete-modal.msg-tech')}
          <span className="text-danger fs-16">{` ${techDisplayName} `}</span>?
        </ModalBody>
        <ModalFooter>
          <Button onClick={close} className="btn btn-ghost-danger">
            {t('Modals.delete-modal.cancel')}
          </Button>

          <Button
            className="btn btn-ghost-success"
            onClick={onDeleteTechnicianFromSite}
            disabled={!objectSlug || !techId}
          >
            {t('Modals.delete-modal.delete')}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DeleteTechnicianModal;
